<template>
  <v-row no-gutters style="padding: 0 15px">
    <v-col cols="12">
      <div
        style="
          font-size: 28px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          margin: 20px 0;
          color: #1b428b;
          font-weight: bold;
        "
      >
        Here is today's Cage Fleet report from VT Electron
      </div>
      <div style="margin: 0 16px 20px 16px">
        <div>
          <span style="font-size: 17px; color: #0581c6">Client: </span><span style="font-size: 16px">{{ tenant }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Report Date: </span
          ><span style="font-size: 16px">{{ report_date }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Report Time: </span
          ><span style="font-size: 16px">{{ report_time }}</span>
        </div>
        <div>
          <span style="font-size: 17px; color: #0581c6">Recepients: </span
          ><span style="font-size: 16px">{{ final_recepient }}</span
          ><span v-if="recipients_number" style="font-size: 12px; color: #0581c6">
            ...+{{ recipients_number }} more</span
          >
        </div>
      </div>
    </v-col>
    <v-col cols="12">
      <div
        style="
          font-size: 24px;
          padding-left: 40px;
          padding-right: 40px;
          text-align: center;
          color: #1b428b;
          font-weight: bold;
        "
      >
        Fleet Report at a glance:
      </div>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12" sm="6" class="d-flex">
              <v-card flat width="100%">
                <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
                  <RadialChartVT
                    title="Total Assets in the Fleet"
                    :subtitle="devices.length"
                    :chartData="chartData"
                    @on-click="apply_graph_filter($event)"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex">
              <v-card flat width="100%">
                <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
                  <RadialChartVT
                    title="Friendly vs Non Friendly"
                    :subtitle="filtered_devices_known.length"
                    :chartData="chart_data_devices_known"
                    @on-click="apply_graph_filter($event)"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex">
              <v-card flat width="100%">
                <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
                  <RadialChartVT
                    title="Value of Assets Outside POIs"
                    :subtitle="devices.length * 100"
                    prefix="€"
                    :chartData="chart_data_monetary"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex">
              <v-card flat width="100%">
                <v-card-text style="padding: 0; background: #ffffff !important" class="pa-0">
                  <RadialChartVT
                    title="Fluid vs Static Assets"
                    :subtitle="devices.length"
                    :chartData="chart_data_device_status"
                    @on-click="apply_graph_filter($event)"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff"> Asset Status </v-card-title>
                <v-card-subtitle style="background: #ffffff"
                  ><b>Fleet Size:</b> {{ devices.length }} Vtags</v-card-subtitle
                >
                <v-card-text>
                  <DataTableVT
                    :headers="page_content.assets_table"
                    :items_list="assets_stats"
                    item_key="id"
                    no_pagination="true"
                    no_sort="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff"> POI Status </v-card-title>
                <v-card-text style="background: #ffffff">
                  <DataTableVT
                    :headers="page_content.poi_table"
                    :items_list="poi_data"
                    sort_by="totalAssets"
                    item_key="LocationID"
                    no_pagination="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff">
                  Assets Outside POIs
                </v-card-title>
                <v-card-text style="background: #ffffff">
                  <DataTableVT
                    :headers="page_content.assets_table"
                    :items_list="outside_poi_stats"
                    item_key="id"
                    no_pagination="true"
                    no_sort="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card flat>
                <v-card-title style="font-size: 20px; color: #1b428b; background: #ffffff">
                  Assets located in Non-Friendly POIs for more than 72 hours
                </v-card-title>
                <v-card-text style="background: #ffffff">
                  <DataTableVT
                    :headers="page_content.non_friendly_table"
                    :items_list="non_friendly_devices"
                    sort_by="totalAssets"
                    item_key="LocationID"
                    no_pagination="true"
                    print="true"
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import RadialChartVT from "../components/RadialChartVT";
import DataTableVT from "../components/DataTableVT";
import { content } from "../../config/reports.json";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];
const api_root = process.env["VUE_APP_ROOT_API"];

export default {
  name: "FleetReport",
  components: {
    RadialChartVT,
    DataTableVT,
  },
  props: {
    report_data: Array,
  },
  watch: {},
  data: function () {
    return {
      tenant: "",
      recepient: "",
      report_date: "",
      report_time: "",
      snackbar: false,
      network_error: false,
      search_term: "",
      error_message: "",
      deviceId: null,
      dialog: false,
      message: "",
      chartOptions: {
        slices: {
          0: { color: "#DB4366" },
          1: { color: "#3B918B" },
        },
        pieHole: 0.4,
      },
      chartOptions2: {
        slices: {
          0: { color: "#f8961e" },
          1: { color: "#B0BEC5" },
        },
        pieHole: 0.4,
      },
      current_list: "all",
      location_data: {},
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    var d = new Date();
    var dd = String(d.getDate()).padStart(2, "0");
    var mm = String(d.getMonth() + 1).padStart(2, "0");
    var yyyy = d.getFullYear();
    var today = dd + "/" + mm + "/" + yyyy;
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.recepient = this.$auth.user.email;
    this.report_date = today;
    this.report_time = d.getHours() + ":" + (d.getMinutes() < 10 ? "0" : "") + d.getMinutes() + ":" + d.getSeconds();
    // this.get_device_list();
    this.get_location_data();
    // this.$store.commit("update_page_title", "Fleet Report");
  },
  filters: {
    timeSince(date_string) {
      var date = new Date(date_string);
      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + " years ago";
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + " months ago";
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + " days ago";
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + " hours ago";
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + " minutes ago";
      }
      return Math.floor(seconds) + " seconds ago";
    },
  },
  methods: {
    apply_graph_filter(val) {
      this.message = val ? "Filter Applied Successfully!" : "Filter Removed Successfully!";
      this.snackbar = true;
      let temp = val.split("(");
      this.current_list = temp[0];
    },
    open_details(deviceId) {
      this.deviceId = deviceId;
      this.dialog = true;
    },
    sort(s) {
      if (s === this.current_sort) {
        this.current_sort_dir = this.current_sort_dir === "asc" ? "desc" : "asc";
      }
      this.current_sort = s;
    },
    next_page: function (a_or_b) {
      if (a_or_b == "a") {
        if (this.current_page_a * this.page_size < this.filtered_devices_known.length) {
          this.current_page_a++;
        }
      } else {
        if (this.current_page_b * this.page_size < this.filtered_devices_unknown.length) {
          this.current_page_b++;
        }
      }
    },
    prev_page: function (a_or_b) {
      if (a_or_b == "a") {
        if (this.current_page_a > 1) this.current_page_a--;
      } else {
        if (this.current_page_a > 1) this.current_page_a--;
      }
    },
    redirect_to: function (deviceID) {
      window.location.href = "https://nimbus.myiot.be/admin/devicemanagement/devices/Device_" + deviceID;
    },

    async get_location_data() {
      //this.$store.commit("show_loader");
      this.network_error = false;
      const accessToken = await this.$auth.getTokenSilently();
      this.network_error = false;
      var self = this;
      const tenant = this.$auth.user[tenant_key]["tenant"];
      let header = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      let locations_req = axios.get(api_root + "/api/location", header);
      let stats_req = axios.get(api_root + "/api/location/stats", header);
      axios
        .all([locations_req, stats_req])
        .then(
          axios.spread((...responses) => {
            let location_data = responses[0].data;
            let stats_data = responses[1].data;
            var hash = new Map();
            location_data.concat(stats_data).forEach(function (obj) {
              hash.set(obj.FullName, Object.assign(hash.get(obj.FullName) || {}, obj));
            });
            location_data = Array.from(hash.values());
            location_data.map((elem) => {
              self.location_data[elem["FullName"]] = elem;
            });
            //self.$store.commit("hide_loader");
          })
        )
        .catch((e) => {
          self.network_error = true;
          //self.$store.commit("hide_loader");
          // self.error_message = e.response.data;
          console.log(e);
        });
    },
  },
  computed: {
    user_account: function () {
      return this.$auth.user;
    },
    devices: function () {
      return this.$store.state.devices || [];
    },
    total_assets: function () {
      return this.devices.length || 0;
    },
    total_assets_known: function () {
      return (
        this.devices.filter((dev) => {
          if (dev.LocationType) {
            return dev.LocationType.toLowerCase().includes("friendly");
          } else {
            return [];
          }
        }).length || 0
      );
    },
    total_assets_unknown: function () {
      return this.total_assets - this.total_assets_known || 0;
    },
    perc_assets_known: function () {
      return Math.round((parseFloat(this.total_assets_known) / this.total_assets) * 100) || 0;
    },
    perc_assets_unknown: function () {
      return Math.round((parseFloat(this.total_assets_unknown) / this.total_assets) * 100) || 0;
    },
    value_missing_assets: function () {
      return this.total_assets_unknown * 100 || 0;
    },
    final_recepient: function () {
      if (this.$route.name == "report_fleet") {
        if (this.report_data && this.report_data[3]) {
          let recepients = "";
          let total = this.report_data[3].length;
          let limit = total > 7 ? 7 : total;
          for (var i = 0; i < limit; i++) {
            recepients = recepients
              ? recepients + "; " + this.report_data[3][i]["RecipientEmail"]
              : this.report_data[3][i]["RecipientEmail"];
          }
          return recepients;
        }
        return this.recepient;
      }
      return this.recepient;
    },
    recipients_number: function () {
      if (this.$route.name == "report_fleet") {
        if (this.report_data && this.report_data[3]) {
          let total = this.report_data[3].length;
          return total > 7 ? total - 7 : null;
        }
        return null;
      }
      return null;
    },
    filtered_devices_known: function () {
      try {
        return this.devices.filter((dev) => {
          return dev.LocationType.toLowerCase().includes("friendly");
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    filtered_devices: function () {
      try {
        var filtered_assets = [];
        if (
          this.devices &&
          this.devices.length > 0 &&
          this.location_data &&
          Object.keys(this.location_data).length > 0
        ) {
          filtered_assets = this.devices
            .filter((dev) => {
              switch (this.current_list.toLowerCase().trim()) {
                case "all":
                  return true;
                case "at poi":
                  return dev.LocationType.toLowerCase().trim().includes("friendly");
                case "outside poi":
                  return !dev.LocationType.toLowerCase().trim().includes("friendly");
                case "friendly":
                  return dev.LocationType.toLowerCase().trim() == "friendly";
                case "non-friendly":
                  return (
                    dev.LocationType.toLowerCase().trim().includes("friendly") &&
                    dev.LocationType.toLowerCase().trim() != "friendly"
                  );
                case "fluid":
                  return dev.DeviceStatus.toLowerCase().trim() == "fluid";
                case "static":
                  return dev.DeviceStatus.toLowerCase().trim() == "static";
                default:
                  return true;
              }
            })
            .map((elem) => {
              elem["LocationID"] = this.location_data[elem["CurrentPOI"]][["LocationID"]];
              elem["FlowRate"] = this.location_data[elem["CurrentPOI"]][["FlowRate"]];
              elem["FluidAssets"] = this.location_data[elem["CurrentPOI"]][["FluidAssets"]];
              elem["FullName"] = this.location_data[elem["CurrentPOI"]][["FullName"]];
              elem["LocationCategory"] = this.location_data[elem["CurrentPOI"]][["LocationCategory"]];
              elem["StaticAssets"] = this.location_data[elem["CurrentPOI"]][["StaticAssets"]];
              elem["TotalAssets"] = this.location_data[elem["CurrentPOI"]][["TotalAssets"]];
              elem["Utilisation"] = this.location_data[elem["CurrentPOI"]][["Utilisation"]];
              return elem;
            });
        }
        return filtered_assets;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    assets_stats: function () {
      return this.report_data && this.report_data[0]
        ? this.report_data[0].filter((elem, key) => {
            if (key <= 7) {
              return elem;
            }
          })
        : [];
    },
    poi_data: function () {
      return this.report_data ? this.report_data[1] : [];
    },
    non_friendly_devices: function () {
      return this.report_data ? this.report_data[2] : [];
    },
    outside_poi_stats: function () {
      return this.report_data && this.report_data[0]
        ? this.report_data[0].filter((elem, key) => {
            if (key > 7) {
              return elem;
            }
          })
        : [];
    },
    chart_data_devices_known: function () {
      let tempObj = {
        activeDevices: 0,
        inactiveDevices: 0,
        devicesAtFriendlyPOI: 0,
        devicesAtNonfriendlyPOI: 0,
      };
      this.filtered_devices_known.forEach(function (item) {
        if (item.DeviceStatus.toLowerCase().trim() == "fluid") tempObj.activeDevices++;
        else tempObj.inactiveDevices++;
        if (item.LocationType.toLowerCase().trim() == "friendly") tempObj.devicesAtFriendlyPOI++;
        else tempObj.devicesAtNonfriendlyPOI++;
      });
      return [
        [
          "Inside Network",
          "Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `Friendly`,
          tempObj.devicesAtFriendlyPOI,
          {
            msg: "Total Assets At Friendly POI",
            title: "Friendly POI",
            footer: `${tempObj.devicesAtFriendlyPOI}(${
              Math.round((tempObj.devicesAtFriendlyPOI / this.filtered_devices_known.length) * 10000) / 100
            }%)`,
          },
        ],
        [
          `Non-friendly`,
          tempObj.devicesAtNonfriendlyPOI,
          {
            msg: "Total Assets at Non-Friendly POI",
            title: "Non-Friendly POI",
            footer: `${tempObj.devicesAtNonfriendlyPOI}(${
              Math.round((tempObj.devicesAtNonfriendlyPOI / this.filtered_devices_known.length) * 10000) / 100
            }%)`,
          },
        ],
      ];
    },
    filtered_devices_unknown: function () {
      try {
        return this.devices.filter((dev) => {
          return !dev.LocationType.toLowerCase().includes("friendly");
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    chartData: function () {
      let total = this.filtered_devices_known.length + this.filtered_devices_unknown.length;
      return [
        [
          "Asset Location",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `At POI`,
          this.filtered_devices_known.length,
          {
            msg: "Total Assets At POI.",
            title: "",
            footer: `${this.$numberWithCommas(this.filtered_devices_known.length)}(${
              Math.round((this.filtered_devices_known.length / total) * 10000) / 100
            }%)`,
          },
        ],
        [
          `Outside POI `,
          this.filtered_devices_unknown.length,
          {
            msg: "Total Assets Outside POI",
            title: "",
            footer: `${this.$numberWithCommas(this.filtered_devices_unknown.length)}(${
              Math.round((this.filtered_devices_unknown.length / total) * 10000) / 100
            }%)`,
          },
        ],
      ];
    },
    chart_data_monetary: function () {
      let total = this.filtered_devices_known.length + this.filtered_devices_unknown.length;
      return [
        [
          "Asset Location",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `At POI (€)`,
          this.filtered_devices_known.length * 100,
          {
            msg: "Total value of Assets At POI.",
            title: "",
            footer: `&euro; ${this.$numberWithCommas(this.filtered_devices_known.length * 100)}(${
              Math.round((this.filtered_devices_known.length / total) * 10000) / 100
            }%)`,
          },
        ],
        [
          `Outside POI (€)`,
          this.filtered_devices_unknown.length * 100,
          {
            msg: "Total value of Assets Outside POI",
            title: "",
            footer: `&euro; ${this.$numberWithCommas(this.filtered_devices_unknown.length * 100)}(${
              Math.round((this.filtered_devices_unknown.length / total) * 1000) / 100
            }%)`,
          },
        ],
      ];
    },
    chart_data_device_status: function () {
      let total = this.filtered_devices_known.length + this.filtered_devices_unknown.length;
      let fluid_assets = 0;
      let static_assets = 0;
      this.devices.forEach(function (item) {
        if (item.DeviceStatus.toLowerCase().trim() == "fluid") fluid_assets++;
        else static_assets++;
      });
      return [
        [
          "Location Type",
          "Total Assets",
          {
            role: "tooltip",
            type: "string",
            p: { html: true, role: "tooltip" },
          },
        ],
        [
          `Fluid`,
          fluid_assets,
          {
            msg: "Total Fluid Assets",
            title: "",
            footer: `${this.$numberWithCommas(fluid_assets)}(${Math.round((fluid_assets / total) * 10000) / 100}%)`,
          },
        ],
        [
          `Static`,
          static_assets,
          {
            msg: "Total Static Assets",
            title: "",
            footer: `${this.$numberWithCommas(static_assets)}(${Math.round((static_assets / total) * 10000) / 100}%)`,
          },
        ],
      ];
    },
  },
};
</script>
